
import { Component, Inject, ElementRef, NgZone, OnInit, ViewChild, AfterViewInit,
   Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
// Breaking version - review & consider a different lib? https://www.npmjs.com/package/@angular/google-maps
import { MapsAPILoader, MouseEvent, AgmMarker } from '@agm/core';

import { Router } from '@angular/router';
import { isNullOrUndefined } from "util";
import { SocoHttpService } from '@app/soco/http';
import { LocationService } from '@app/shared/services';
import { ConstantsService } from '@app/base/core';

declare var swal: any;
require('sweetalert');

declare var google: any;

@Component({
  selector: 'gre-map',
  template: `
    <agm-map id='LocationDetail' #gm [latitude]='latitude' [longitude]='longitude' (mapClick)='mapClicked($event)' [scrollwheel]='false'
      [zoom]='zoom' [mapDraggable]='true' [mapTypeControl]='mapTypeControl' [clickableIcons]='false'
      [streetViewControl]="false">
      <agm-marker #m *ngIf='showMarker' (dragEnd)="markerDragEnd($event)" [latitude]='latitude' [longitude]='longitude'
       [markerDraggable]='true'
        (markerClick)="markerClicked($event)">
        <agm-info-window #infowindow [disableAutoPan]="false" [isOpen]='infoWindowOpen'>
          <div>
            <span class="text-size-small grey">Your current address</span>
            <p class="text-bold text-address">{{addressFromMarker }}</p>
            <div class="button-container">
              <button class="btn btn-primary" (click)="clickedYes()">Confirm</button>
              <span class="text-bold "> or Drag the pin to change the address</span>
            </div>
          </div>
        </agm-info-window>
      </agm-marker>
    </agm-map>
    <div class="agm-map-overlay">
      <div class="form-group">
        <input type="search" [(ngModel)]="addressSearchText" class="form-control input-lg"
        placeholder="Enter the Service Address" autocorrect='on'
          #search autocapitalize='on' spellcheck='off'>
      </div>
    </div>
`,
  styles: [`
  agm-map {
    height: 600px;
    position: relative
  }
  .agm-map-overlay {
    position: absolute;
    top: 10px;
    left: 220px;
  }
  input[type=search]::-webkit-search-cancel-button {
    -webkit-appearance: searchfield-cancel-button
  }
  .agm-map-overlay input {
    border-radius: 0px;
    border: 1px solid #c4baba
  }
  .text-address {
    max-width: 310px !important;
}

@media only screen and (min-width: 1000px) {
  .agm-map-overlay {
    width: 65%;
  }
}
@media only screen and  (max-width: 999px) and (min-width: 771px) {
  .agm-map-overlay {
    width: 65%;
  }
}
  @media only screen and (max-width: 770px) and (min-width: 600px) {
    .agm-map-overlay {
      width: 60%;
    }
  }

  @media only screen and (max-width: 599px) and (min-width: 451px) {
    .agm-map-overlay {
      width: 55%;
    }
  }


  @media only screen and (max-width: 450px) {
    agm-map {
      height: 550px;
    }
    .agm-map-overlay {
      width: 90%;
      top: 50px;
      left: 20px;
    }
    .button-container, .text-address{
      width:220px;
    }
    .button-container button {
      display: block;
  }}
  `]
})
/* istanbul ignore next */
export class CustomMapComponent implements OnInit, AfterViewInit, OnDestroy {
  ngOnDestroy(): void {
    if ($('.swal-modal').is(':visible')) {
      swal.close();
    }
  }
  @Input() latLng: any = null;
  @Output() getSelectedAddress = new EventEmitter();
   @Input() sorryNotification: any[];
  public mapTypeControl: any;
  public latitude: number;
  public longitude: number;
  public lat: number;
  public location: any = {};
  public long: number;
  public searchControl: FormControl;
  public zoom: number;
  public markerDraggable = false;
  public marker: Marker;
  public showMarker = false;
  public infoWindowOpen: boolean;
  public mapTypeId: string;
  public errorMsg: string;
  public addressFromMarker: any;
  public showAddress = true;
  addressSearchText: string;
  map: any;
  selectedAddress: any = {};
  @ViewChild('search', {static: false})
  public searchElementRef: ElementRef;
  @ViewChild('infowindow', {static: false})
  public infoWindow;
  isServiceable: any;

  constructor(
      @Inject(MapsAPILoader) private mapsAPILoader: MapsAPILoader,
      @Inject(NgZone) private ngZone: NgZone,
      @Inject(Router) private router: Router,
      public constantsSvc: ConstantsService,
      private locationService: LocationService,
      private http: SocoHttpService
  ) {
    this.zoom = 5;
    this.latitude = 37.1147781;
    this.longitude = -96.1683426;
  }

  /* istanbul ignore next */
  ngOnInit() {
    this.latitude = this.latLng.lat;
    this.longitude = this.latLng.lng;
    this.zoom = this.latLng.zoom;
    if (this.latLng.showMarker) {
      this.getGeoLocation(this.latitude, this.longitude);
      this.showMarker = true;
      this.infoWindowOpen = true;
    }
    this.mapsAPILoader.load().then(() => {
      this.searchControl = new FormControl();
      const options = { componentRestrictions: { country: 'US' } };
      const autocomplete = new google.maps.places.SearchBox(this.searchElementRef.nativeElement, options);
      autocomplete.addListener('bounds_changed', () => {
        this.ngZone.run(() => { autocomplete.setBounds(this.map.getBounds()); });
      });
      autocomplete.addListener('places_changed', () => {
        this.ngZone.run(() => {
          const place: any = autocomplete.getPlaces();
          if (place.length === 0) {
            swal(this.constantsSvc.addressNotFoundSwal, this.constantsSvc.addressSwal1, 'warning');
            return;
          }
          if (!place[0].address_components && place[0].types[0] === 'route') {
            swal(this.constantsSvc.addressNotFoundSwal, this.constantsSvc.addressNotFound, 'warning');
            return;
          // tslint:disable-next-line: no-duplicated-branches
          } else if (place[0].address_components) {
            // tslint:disable-next-line: no-collapsible-if
            if (place[0].address_components[0].types[0] !== 'street_number') {
              swal(this.constantsSvc.addressNotFoundSwal, this.constantsSvc.addressNotFound, 'warning');
            }
          }

          this.latitude = place[0].geometry.location.lat();
          this.longitude = place[0].geometry.location.lng();
          this.zoom = 15;
          if (place[0].address_components != null) {
            this.addressFromMarker = place[0].formatted_address;
            this.selectedAddress = this.parseAddress(place[0]);
          } else {
            this.getGeoLocation(this.latitude, this.longitude);
            this.selectedAddress.latitude = this.latitude;
            this.selectedAddress.latitude = this.longitude;
            this.selectedAddress.zoomLevel = this.zoom;
          }
          this.showMarker = true;
          this.infoWindowOpen = true;
        });
      });
    });
  }
  ngAfterViewInit(): void {

  }
  mapReadyHandler(map): void {
    this.map = map;
  }
  // setCurrentPosition() {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition((position) => {
  //       this.latitude = position.coords.latitude;
  //       this.longitude = position.coords.longitude;
  //       this.zoom = 14;
  //     });
  //     this.showMarker = true;
  //     this.infoWindowOpen = false;
  //   }
  // }

  /* istanbul ignore next */
  getGeoLocation(lat: number, lng: number) {
    if (navigator.geolocation) {
      const geocoder = new google.maps.Geocoder();
      const latlng = new google.maps.LatLng(lat, lng);
      const request = { latLng: latlng };
      geocoder.geocode(request, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          this.addressFromMarker = results[0].formatted_address;
          this.selectedAddress = this.parseAddress(results[0]);
          this.addressSearchText = this.addressFromMarker;
        }
      });
    }
  }
  /* istanbul ignore next */
  mapClicked($event: MouseEvent) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.getGeoLocation($event.coords.lat, $event.coords.lng);
    this.showMarker = true;
    this.infoWindowOpen = true;
  }
  /* istanbul ignore next */
  markerClicked($event) {
    this.infoWindowOpen = true;
    this.getGeoLocation(this.latitude, this.longitude);
  }
  /* istanbul ignore next */
  markerDragEnd($event: MouseEvent) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.getGeoLocation(this.latitude, this.longitude);
    this.infoWindowOpen = true;
  }
  /* istanbul ignore next */
  parseAddress(addressObj) {
    const address: any = {};
    if (addressObj != null) {
      // loop through to get address, city, state, zip
      $.each(addressObj.address_components, function () {
        switch (this.types[0]) {
          case 'route':
            address.street_name = this.short_name;
            break;
          case 'street_number':
            address.street_number = this.short_name || '';
            break;
          case 'locality':
            address.city = this.short_name;
            break;
          case 'administrative_area_level_2':
            address.county = this.long_name.substring(0, this.long_name.length - 7);
            break;
          case 'administrative_area_level_1':
            address.state = { long_name: this.long_name, short_name: this.short_name };
            break;
          case 'postal_code':
            address.zip = this.short_name;
            break;
          case 'country':
            address.country = this.short_name;
            break;
        }
      });
    }
    address.formatted_address = addressObj.formatted_address;
    address.latitude = this.latitude;
    address.longitude = this.longitude;
    address.zoomLevel = this.zoom;
    return address;
  }
  /* istanbul ignore next */
  clickedYes() {
    if (isNullOrUndefined(this.selectedAddress['county'])) { this.selectedAddress.county = 'NA'; }

    if (!this.selectedAddress.street_number || !this.selectedAddress.street_name ||
       !this.selectedAddress.city || !this.selectedAddress.zip) {
      // swal(this.constantsSvc.errorSwal1, this.constantsSvc.addressSwal2, this.constantsSvc.errorSwal);
      return;
    }
    this.location.latitude = this.latitude.toString();
    this.location.longitude = this.longitude.toString();
    this.location.state = this.selectedAddress.state.short_name;
    this.locationService.isLocationServicableById(this.location).subscribe(result => {
      this.isServiceable = result.data;
      this.selectedAddress.serviceCenter = result.data.serviceCenter;
      this.selectedAddress.localDistrict = result.data.localDistrict;
      this.selectedAddress.localDistrictCd = result.data.localDistrictCd;
      this.selectedAddress.xCoordinate = result.data.xCoordinate;
      this.selectedAddress.yCoordinate = result.data.yCoordinate;
      if (this.selectedAddress.county === 'NA') {
        this.selectedAddress.county = result.data.county;
      }
      const msg = document.createElement('div');
      //Default
      let LDC;
      if (this.selectedAddress.state.short_name === 'GA') {
        LDC = 'an Atlanta Gas Light';
      }
      if (this.selectedAddress.state.short_name === 'TN') {
        LDC = 'a Chattanooga Gas';
      }
      if (this.selectedAddress.state.short_name === 'VA') {
        LDC = 'a Virginia Natural Gas';
      }

      const message = `<strong>This address is in our service area. <strong><p> Natural gas service is not guaranteed. Please request service and ${LDC} representative will contact you to confirm service availability and cost details.</p>`;

      msg.innerHTML = message;
      if (this.isServiceable.isServicable === 'True') {
        swal({
          content: { element: msg},
          icon: 'assets/images/icons/icon_94_tumbs-up-green.svg',
          buttons: {
            cancel: { text: 'Cancel', visible: true, value: false, closeModal: true },
            confirm: { text: 'Proceed', value: true, closeModal: true }
          }
        }).then((result) => {
          if (!result) { return; }
          // emit selected address as output to other component
          this.getSelectedAddress.emit(this.selectedAddress);
        });
      } else if (this.isServiceable.isServicable === 'False') {
        this.SorryNotification();
      }
    }, response => {
      if (this.http.isInvalidResult(response)) {
        swal(this.constantsSvc.errorSwal1, this.constantsSvc.contactCustomerCareSwal, this.constantsSvc.errorSwal);
      } else if (response.statusCode === 500) {
        swal(this.constantsSvc.errorSwal1, this.constantsSvc.exceptionError, this.constantsSvc.errorSwal);
      }
    });
  }
  /* istanbul ignore next */
  SorryNotification() {
    const msg1 = document.createElement('div');
    if (this.selectedAddress.state.short_name === 'GA') {
      msg1.innerHTML = this.sorryNotification.filter(a => a['itemName'] === 'GA')[0]['message'];
    } else {
      msg1.innerHTML = this.sorryNotification.filter(a => a['itemName'] === 'TN')[0]['message'];
    }

    swal({
      icon: 'assets/images/icons/no-service-in-locality icon.png',
      content: {
        element: msg1
      },
      buttons: {
        cancel: { text: 'Ok', visible: true, value: false, closeModal: true },
      },
    });
  }
}
interface Marker {
  latitude: number;
  longitude: number;
  draggable: boolean;
}
